/* ============================================================
   ACSY COMPLETE THE LOOK — Cart Complementary Products
   
   Extracted from cart-summary.liquid to ensure the script
   actually executes. Inline <script> tags inside HTML that's
   inserted via innerHTML (like Horizon's cart drawer refresh)
   don't execute — but properly loaded external JS files do,
   and event delegation on `document` persists across renders.
   
   Load this from theme.liquid <head>:
     <script src="{{ 'acsy-atl.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  // ============================================================
  // Event delegation — attached ONCE to document.
  // Persists across cart drawer refreshes, section renders, etc.
  // ============================================================

  // Size dropdown → enables Add button
  document.addEventListener('change', function (e) {
    const select = e.target.closest('select[data-acsy-atl-select]');
    if (!select) return;

    const form = select.closest('[data-acsy-atl-form]');
    if (!form) return;

    const btn = form.querySelector('[data-acsy-atl-add]');
    if (btn) btn.disabled = !select.value;
  });

  // Add button clicks
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-acsy-atl-add]');
    if (!btn) return;

    e.preventDefault();
    if (btn.disabled) return;

    handleAdd(btn);
  });

  async function handleAdd(btn) {
    const form = btn.closest('[data-acsy-atl-form]');
    const select = form.querySelector('[data-acsy-atl-select]');
    const variantId = select.value;
    if (!variantId) return;

    const card = btn.closest('[data-acsy-atl-card]');
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.description || 'Add to cart failed');
      }

      // Animate card out
      if (card) card.classList.add('acsy-atl__card--added');

      // Dispatch update events (NOT cart:add which triggers auto-open logic)
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      // Refresh cart drawer content via Section Rendering API
      await refreshCartDrawer();

      // Remove card from DOM after animation
      if (card) setTimeout(() => card.remove(), 400);
    } catch (err) {
      console.error('[Acsy ATL] Add failed:', err);
      btn.disabled = false;
      btn.textContent = originalText;
      alert('Could not add item. Please try again.');
    }
  }

  async function refreshCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;

    const wasOpen = cartDrawer.hasAttribute('open') ||
                    cartDrawer.querySelector('dialog[open]') !== null;

    const sectionEl = cartDrawer.closest('[id^="shopify-section-"]');
    if (!sectionEl) return;

    const sectionId = sectionEl.id.replace('shopify-section-', '');

    try {
      const response = await fetch(`${window.location.pathname}?section_id=${sectionId}`, {
        headers: { 'Accept': 'text/html' }
      });
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer-component');
      if (newDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
        // No re-init needed — event delegation handles new elements automatically

        // Force drawer to stay open after refresh
        if (wasOpen && typeof cartDrawer.open === 'function') {
          setTimeout(() => cartDrawer.open(), 50);
        }
      }
    } catch (err) {
      console.warn('[Acsy ATL] Section refresh failed:', err);
    }
  }
})();
